import http from '@/services/http';
import { sectorsAssociationFilters } from '@/config';
import tableHelper from '@/services/tableHelper';

const locationsManagement = {
  index(tableFilters, filterStatus, config = {}) {
    const filters = tableHelper.whereFilters(
      filterStatus,
      sectorsAssociationFilters
    );
    return http.request({
      method: 'get',
      url: '/location-sector-departments',
      params: {
        filter: { ...tableFilters, where: filters, include: ['location'] },
      },
      ...config,
    });
  },
  count(filterStatus, config = {}) {
    const where = tableHelper.whereFilters(
      filterStatus,
      sectorsAssociationFilters
    );
    return http.request({
      method: 'get',
      url: '/location-sector-departments/count',
      params: { where },
      ...config,
    });
  },
  create(data) {
    return http.request({
      method: 'post',
      url: '/location-sector-departments',
      data,
    });
  },
  patch(id, data) {
    return http.request({
      method: 'patch',
      url: `/location-sector-departments/${id}`,
      data,
    });
  },
  delete(id) {
    return http.request({
      method: 'delete',
      url: `/location-sector-departments/${id}`,
    });
  },
};

export default locationsManagement;
